import React from 'react';
import Header from '../components/Header';
import SEO from '../components/SEO';

const PurposeMapProductPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO 
        title="Motivation & Values Assessment Nigeria | PurposeMap™ Lagos"
        description="PurposeMap™ motivation and values assessment for Nigerian leaders. Understand what drives a leader and where they want to go next. Purpose-built for African leadership development."
        keywords="motivation assessment Nigeria, values assessment Lagos, career drivers Nigeria, leadership motivation Africa, PurposeMap"
        canonical="https://impactasportal.com/product/purposemap"
      />
      <Header />
      
      {/* Main Content - Iframe Container */}
      <main className="flex-1 pt-20">
        <div className="w-full h-[calc(100vh-80px)]">
          <iframe
            src="https://impactasportal.com/product/purposemap?embed=true"
            title="PurposeMap™ - Impact AS Plus"
            className="w-full h-full border-0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-modals allow-popups-to-escape-sandbox"
          />
        </div>
      </main>
    </div>
  );
};

export default PurposeMapProductPage;
